import React, { useContext, useEffect, useState, useMemo } from "react";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid, Box } from "@material-ui/core";
import { TextField } from "@mui/material";
import { MyContext } from './../../../context/MyContext';
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import api from '../../../services/api';
import * as locales from '@mui/material/locale';
import axios from 'axios';
import { styled } from "@mui/material/styles";
import InputMask from 'react-input-mask';
import { BrowserView, MobileView } from "react-device-detect";

const style = {
  position: 'absolute',
  top: '10%',
  left: '10%',
  right: "10%",
  overflow: 'scroll',
  height: '100%',
  display: 'block',
  bgcolor: 'background.paper',
  boxShadow: 24
}

export default function ModalDadosPessoaisDetalhes(props) {
  const [open, setOpen] = React.useState(false);
  const produto = props?.props;

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const idCliente = props?.props;  // Concatenado Id_Loja
  const { showModalDadosPessoais, setShowModalDadosPessoais } = useContext(MyContext);
  const { usuarioEfetuouLogin, setUsuarioEfetuouLogin } = useContext(MyContext);
  const { usuarioEfetuouLoginEMail, setUsuarioEfetuouLoginEMail } = useContext(MyContext);
  const { meuContatoEntrega, setMeuContatoEntrega } = useContext(MyContext);
  const { atualizarPagina, setAtualizarPagina } = useContext(MyContext);
  const { meuCredito, setMeuCredito } = useContext(MyContext);
  const [cidadeSelecionada, setCidadeSelecionada] = useState(0);
  const [meusContatos, setMeusContatos] = useState([]);
  const [locale, setLocale] = useState('ptBR');
  const theme = useTheme();
  const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);
  const [fretes, setFretes] = useState([]);
  const [freteError, setFreteError] = useState("");
  const [idsContatos, setIdsContatos] = useState(0);
  const [idsLojaContatos, setIdsLojaContatos] = useState(0);
  const [idClientesContatos, setIdClientesContatos] = useState(0);
  const [idLojaContatos, setIdLojaContatos] = useState(0);
  const [reEmail, setReEmail] = useState('');
  const [cpf_cnpj, setCpf_Cnpj] = useState('');
  const [labelCpf_Cnpj, setLabelCpf_Cnpj] = useState("CPF:");
  const [ie_rg, setIe_Rg] = useState('');
  const [razao_social, setRazao_Social] = useState('');
  const [apelidoCont, setApelidoCont] = useState("PESSOAL");
  const [rua, setRua] = useState("");
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [iduf, setIduf] = useState(0);
  const [uf, setUf] = useState("");
  const [idcidade, setIdcidade] = useState(0);
  const [cidade, setCidade] = useState("");
  const [cep, setCep] = useState("");
  const [referencia, setReferencia] = useState("");
  const [padraoContatos, setPadraoContatos] = useState(0);
  const [ativoContatos, setAtivoContatos] = useState(1);
  const [extUf, setExtUf] = useState("");
  const [extCidade, setExtCidade] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [botaoPadrao, setBotaoPadrao] = useState(true);
  const [editarReadOnly, setEditarReadOnly] = useState(true);
  const [ContatoSelecionado, setContatoSelecionado] = useState([]);
  const [naoEditarFaturado, setNaoEditarFaturado] = useState(false);
  const [maskCpf_Cnpj, setMaskCpf_Cnpj] = useState("999.999.999-99");
  const [existemErros, setExistemErros] = useState('');
  const [openDadosPessoais, setOpenDadosPessoais] = React.useState(false);
  setAtualizarPagina(false);

  useEffect(() => {
    BuscarMeusDadosPessoais();
  }, []);

  function BuscarMeusDadosPessoais() {
    if (usuarioEfetuouLogin == null || usuarioEfetuouLogin == "" || usuarioEfetuouLogin.length == 0) {
      return;
    }
    if (usuarioEfetuouLogin.indexOf('_') == -1) {
      return;
    }
    api.get(`/Clientes/ClienteInfo/` + usuarioEfetuouLogin.split('_')[0] + `/` + usuarioEfetuouLogin.split('_')[1])
      .then((response) => {
        if (response === null) {
          return;
        }
        setRazao_Social(response.data.nome);
        setCpf_Cnpj(response.data.cpf);
        setIe_Rg(response.data.ie_Rg);
        setEmail(response.data.contatos[0].email);
        setReEmail(response.data.contatos[0].email);
      })
      .catch((error) => {
        console.log(error.message)
      });
  }

  const handleCpfCnpj = (e) => {
    setCpf_Cnpj(e.target.value);
  }

  const handleIe_Rg = (e) => {
    setIe_Rg(e.target.value);
  }

  const handleEmail = (e) => {
    setEmail(e.target.value);
  }

  const themeTextFieldDisabled = createTheme({
    palette: {
      label: {
        disabled: '#FF0000'
      },

      text: {
        disabled: '#000'
      }
    },
  });

  const stylesLabelDisabled = {
    floatingLabelFocusStyle: {
      color: "#FF0000"
    }
  }

  const handleRazao_Social = (e) => {
    setRazao_Social(e.target.value);
  }

  const handleSalvarDadosPessoais = () => {
    if (razao_social == null || razao_social == "" || razao_social.length < 5) {
      setExistemErros("Digite Seu Nome Completo...");
      return;
    }
    setOpenDadosPessoais(false);
    // setShowModalDadosPessoais(false);
  }

  const handleCloseDadosPessoais = () => {
    setOpen(false);
  }

  return (
    <div>
      <BrowserView>
        <Box marginTop={"35px"} marginRight={"56px"}>
          <Button variant="contained" onClick={(e) => handleOpen(e)} style={{ backgroundColor: '#357a38', maxHeight: '25px' }}>MEUS DADOS PESSOAIS</Button>
        </Box>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <ThemeProvider theme={themeWithLocale}>
                <Grid container justifyContent={"left"} spacing={1} paddingLeft={'10px'}>
                  <Grid item xs={12} textAlign={'left'} marginLeft={'12px'}>
                    <Typography variant='h11' paddingLeft={'8px'}>
                      Meus Dados Pessoais:
                    </Typography>
                  </Grid>
                  <Grid item xs={6} paddingLeft={'5px'}>
                    <Box paddingLeft={'8px'}>
                      <TextField
                        fullWidth
                        id="Email"
                        value={email}
                        onChange={(event) => {
                          handleEmail(event);
                        }}
                        autoFocus
                        label="E-mail:"
                        variant="outlined"
                        required
                        disabled={true}
                      />
                    </Box>
                  </Grid>

                  {/* <Grid item xs={6}>
                        <Box paddingRight={'8px'}>
                        <TextField
                          fullWidth
                          id="re_email"
                          value={reEmail}
                          onChange={(event) => {
                            handleReEmail(event);
                          }}
                          label="Confirme Seu E-mail:"
                          variant="outlined"
                          required
                        />
                        </Box>
                      </Grid> */}

                  <Grid item xs={3}>
                    <Box paddingLeft={'8px'}>
                      <InputMask mask={maskCpf_Cnpj} maskPlaceholder=" " value={cpf_cnpj}
                        InputProps={{ readOnly: naoEditarFaturado }}
                        disabled={true}
                        onChange={(event) => {
                          handleCpfCnpj(event)
                        }}>
                        <TextField
                          fullWidth
                          id="cpf_cnpj"
                          required
                          label={labelCpf_Cnpj}
                          variant="outlined">
                        </TextField>
                      </InputMask>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box paddingRight={'8px'}>
                      <TextField
                        fullWidth
                        id="Ie_Rg"
                        value={ie_rg}
                        InputProps={{ readOnly: naoEditarFaturado }}
                        onChange={(event) => { handleIe_Rg(event) }}
                        // required
                        disabled={true}
                        label="Identidade:"
                        variant="outlined">
                      </TextField>
                    </Box>
                  </Grid>

                  <Grid item xs={6} paddingRight={'10px'}>
                    <Box paddingLeft={'8px'}>
                      <TextField
                        fullWidth
                        id="Nome"
                        label="Nome Completo:"
                        value={razao_social}
                        onChange={(event) => { handleRazao_Social(event) }}
                        InputProps={{ readOnly: naoEditarFaturado }}
                        required
                        disabled={true}
                      />
                    </Box>
                  </Grid>

                  {/* <Grid item xs={2.3}>
                        <Box paddingLeft={'8px'}>
                        <InputMask mask="(99) 9999-9999" maskPlaceholder=" ">
                          <TextField
                            fullWidth
                            id="telefoneFixo"
                            // value={this.state.cliente.CpfCnpj}
                            // onChange={e => this.handleCliente(e)}
                            // required
                            label="Telefone Fixo:"
                            variant="outlined">
                          </TextField>
                        </InputMask>
                        </Box>      
                      </Grid>
                      <Grid item xs={2.3}>
                        <InputMask mask="(99) 99999-9999" maskPlaceholder=" ">
                          <TextField
                            fullWidth
                            id="telefoneCelular"
                            // value={this.state.cliente.CpfCnpj}
                            // onChange={e => this.handleCliente(e)}
                            required
                            label="Telefone Celular:"
                            variant="outlined">
                          </TextField>
                        </InputMask>
                      </Grid> */}

                  {/* <Grid item xs={3.00}>
                        <Box paddingLeft={'8px'}>
                        <TextField
                          fullWidth
                          id="SenhaSite"
                          // value={this.state.cliente.SenhaSite}
                          // onChange={e => this.handleCliente(e)}
                          label="Digite a Sua Senha:"
                          type="password"
                          required
                        />
                        </Box>
                      </Grid> */}

                  <Grid item xs={3.00}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button disabled onClick={e => handleSalvarDadosPessoais(e)} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '150px', marginTop: '11px' }}>Salvar</Button>
                    </Box>
                  </Grid>
                  <Grid item xs={3.00}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button onClick={e => handleCloseDadosPessoais(e)} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', marginTop: '11px', width: '150px' }}>Cancelar</Button>
                    </Box>
                  </Grid>

                  <Grid item xs={3.00}>
                    {/* <TextField
                          fullWidth
                          id="ReSenhaSite"
                          // value={this.state.cliente.SenhaSite}
                          // onChange={e => this.handleCliente(e)}
                          label="Repita a Senha:"
                          type="password"
                          required
                        /> */}
                  </Grid>


                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Typography variant='h11' paddingLeft={'8px'}>
                        {existemErros}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </ThemeProvider>
              {/* ) */}
            </Box>
          </Fade>
        </Modal>
      </BrowserView>

      <MobileView>
        <Box marginTop={"35px"} marginRight={"35px"}>
          <Button variant="contained" onClick={(e) => handleOpen(e)} style={{ backgroundColor: '#357a38', maxHeight: '25px', minWidth: '170px' }}>DADOS PESSOAIS</Button>          
        </Box>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <ThemeProvider theme={themeWithLocale}>
                <Grid container justifyContent={"left"} spacing={1} paddingLeft={'10px'}>
                  <Grid item xs={12} textAlign={'left'} marginLeft={'12px'}>
                    <Typography variant='h11' paddingLeft={'8px'}>
                      Meus Dados Pessoais:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} paddingLeft={'5px'}>
                    <Box paddingLeft={'8px'}>
                      <TextField
                        fullWidth
                        id="Email"
                        value={email}
                        onChange={(event) => {
                          handleEmail(event);
                        }}
                        autoFocus
                        label="E-mail:"
                        variant="outlined"
                        required
                        disabled={true}
                      />
                    </Box>
                  </Grid>

                  {/* <Grid item xs={6}>
                        <Box paddingRight={'8px'}>
                        <TextField
                          fullWidth
                          id="re_email"
                          value={reEmail}
                          onChange={(event) => {
                            handleReEmail(event);
                          }}
                          label="Confirme Seu E-mail:"
                          variant="outlined"
                          required
                        />
                        </Box>
                      </Grid> */}

                  <Grid item xs={12}>
                    <Box paddingLeft={'8px'}>
                      <InputMask mask={maskCpf_Cnpj} maskPlaceholder=" " value={cpf_cnpj}
                        InputProps={{ readOnly: naoEditarFaturado }}
                        disabled={true}
                        onChange={(event) => {
                          handleCpfCnpj(event)
                        }}>
                        <TextField
                          fullWidth
                          id="cpf_cnpj"
                          required
                          label={labelCpf_Cnpj}
                          variant="outlined">
                        </TextField>
                      </InputMask>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box paddingLeft={'8px'}>
                      <TextField
                        fullWidth
                        id="Ie_Rg"
                        value={ie_rg}
                        InputProps={{ readOnly: naoEditarFaturado }}
                        onChange={(event) => { handleIe_Rg(event) }}
                        // required
                        disabled={true}
                        label="Identidade:"
                        variant="outlined">
                      </TextField>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box paddingLeft={'8px'}>
                      <TextField
                        fullWidth
                        id="Nome"
                        label="Nome Completo:"
                        value={razao_social}
                        onChange={(event) => { handleRazao_Social(event) }}
                        InputProps={{ readOnly: naoEditarFaturado }}
                        required
                        disabled={true}
                      />
                    </Box>
                  </Grid>

                  {/* <Grid item xs={2.3}>
                        <Box paddingLeft={'8px'}>
                        <InputMask mask="(99) 9999-9999" maskPlaceholder=" ">
                          <TextField
                            fullWidth
                            id="telefoneFixo"
                            // value={this.state.cliente.CpfCnpj}
                            // onChange={e => this.handleCliente(e)}
                            // required
                            label="Telefone Fixo:"
                            variant="outlined">
                          </TextField>
                        </InputMask>
                        </Box>      
                      </Grid>
                      <Grid item xs={2.3}>
                        <InputMask mask="(99) 99999-9999" maskPlaceholder=" ">
                          <TextField
                            fullWidth
                            id="telefoneCelular"
                            // value={this.state.cliente.CpfCnpj}
                            // onChange={e => this.handleCliente(e)}
                            required
                            label="Telefone Celular:"
                            variant="outlined">
                          </TextField>
                        </InputMask>
                      </Grid> */}

                  {/* <Grid item xs={3.00}>
                        <Box paddingLeft={'8px'}>
                        <TextField
                          fullWidth
                          id="SenhaSite"
                          // value={this.state.cliente.SenhaSite}
                          // onChange={e => this.handleCliente(e)}
                          label="Digite a Sua Senha:"
                          type="password"
                          required
                        />
                        </Box>
                      </Grid> */}

                  <Grid item xs={6.00}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button disabled onClick={e => handleSalvarDadosPessoais(e)} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '150px', marginTop: '11px' }}>Salvar</Button>
                    </Box>
                  </Grid>
                  <Grid item xs={6.00}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button onClick={e => handleCloseDadosPessoais(e)} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', marginTop: '11px', width: '150px' }}>Cancelar</Button>
                    </Box>
                  </Grid>

                  <Grid item xs={12.00}>
                    {/* <TextField
                          fullWidth
                          id="ReSenhaSite"
                          // value={this.state.cliente.SenhaSite}
                          // onChange={e => this.handleCliente(e)}
                          label="Repita a Senha:"
                          type="password"
                          required
                        /> */}
                  </Grid>


                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Typography variant='h11' paddingLeft={'8px'}>
                        {existemErros}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </ThemeProvider>
              {/* ) */}
            </Box>
          </Fade>
        </Modal>
      </MobileView>
    </div>
  );
}
